/* eslint-disable global-require */
const List = () => import('./main.vue');

export default [
  {
    name: 'envio-email-prestador',
    path: '/envio-email-prestador',
    components: { default: List },
    meta: {
      requiresAuth: true,
      breadcrum: 'Envio Email Prestador (Atualização Cadastro)',
      icon: 'envelope-square',
      can: 'list',
      on: 'envioemailprestador',
    },
  },
];
